import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcBuild32 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 32,
	viewBox: "0 0 32 32",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m21 2a9 9 0 0 0 -9 9c0 1.075.202 2.018.429 2.75l-10.81 10.799a1 1 0 0 0 .017 1.432l4.508 4.29a.999.999 0 0 0 1.416 0l10.696-10.699c.866.285 1.78.428 2.744.428a9 9 0 0 0 9-9c0-1.175-.244-2.52-.713-3.498-.273-.572-1.103-.695-1.58-.22l-3.722 3.721-2.997-2.996 3.72-3.717a1 1 0 0 0 -.33-1.635 8.977 8.977 0 0 0 -3.378-.655zm1.084 2.084-3.217 3.216a1 1 0 0 0 0 1.414l4.378 4.382c.432.458 1.087.39 1.447.03l3.221-3.221a7 7 0 0 1 -6.913 8.095c-.918 0-1.578-.123-2.713-.538a.986.986 0 0 0 -.996.249l-10.456 10.456-3.077-2.929 10.534-10.522a1 1 0 0 0 .22-1.083 7 7 0 0 1 7.572-9.549z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcBuild32;
